@if (group) {
  <div [formGroup]="group">
    <mat-form-field>
      <textarea
        cdkTextareaAutosize
        cdkAutosizeMaxRows="10"
        #autosize="cdkTextareaAutosize"
        matInput
        formControlName="value"
        placeholder="Input value"
        rows="1"
        [attr.maxlength]="group.get('validators')?.value.maxLength || null"></textarea>
      <mat-hint align="end">
        {{ group.get('value')?.value?.length || 0 }} / {{ group.get('validators')?.value.maxLength }}
      </mat-hint>
      @if (showHint) {
        <mat-hint>{{ group.get('customFieldType')?.value | customFieldType }}</mat-hint>
      }
    </mat-form-field>
  </div>
}
